import React, { Fragment } from "react";

import img13 from "../../../images/service/supplychain/supply-chain-blockchain-banner1.jpg";
import img14 from "../../../images/service/supplychain/supply-chain-blockchain-banner2.jpg";
import img15 from "../../../images/service/supplychain/supply-chain-blockchain-banner3.jpg";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "End-to-End Supply Chain Tracking",
    content:
      "Track goods from origin to delivery with immutable blockchain records for complete visibility.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Automation",
    content:
      "Automate supplier agreements, payments, and compliance using secure smart contracts.",
  },
  {
    icon: sIcon3,
    title: "Product Traceability Solutions",
    content:
      "Verify product authenticity and provenance to prevent counterfeiting and fraud.",
  },
];

const benefits = [
  {
    title: "Complete Transparency",
    description:
      "Blockchain provides a single source of truth across suppliers, manufacturers, and distributors.",
    icon: sIcon1,
  },
  {
    title: "Fraud Prevention",
    description:
      "Immutable records reduce manipulation, counterfeit goods, and data tampering.",
    icon: sIcon2,
  },
  {
    title: "Operational Efficiency",
    description:
      "Automation reduces paperwork, manual reconciliation, and delays.",
    icon: sIcon3,
  },
  {
    title: "Improved Trust",
    description:
      "All stakeholders access verified and auditable supply chain data.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "How does blockchain improve supply chain management?",
    a: "Blockchain improves transparency, traceability, and trust by recording every transaction on a shared, immutable ledger.",
  },
  {
    q: "Can blockchain prevent counterfeit products?",
    a: "Yes. Blockchain enables end-to-end traceability, helping verify product origin and authenticity.",
  },
  {
    q: "Is blockchain suitable for global supply chains?",
    a: "Absolutely. Blockchain supports secure data sharing across borders and multiple stakeholders.",
  },
  {
    q: "Can blockchain integrate with existing ERP systems?",
    a: "Yes. Blockchain solutions can integrate seamlessly with existing supply chain and ERP platforms.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function SupplyChainBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Supply Chain Blockchain Development"
        pagesub="Transparent, secure & efficient supply chain solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Transform Supply Chains with{" "}
            <span className="gradient-text">Blockchain Technology</span>
          </>
        }
        subtitle={`Improve visibility, traceability, and trust across your
supply chain using secure blockchain-powered solutions.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Supply Chain Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Supply Chain?"
        image={img14}
        paragraphs={[
          "Modern supply chains involve multiple stakeholders, complex logistics, and global operations. Traditional systems often suffer from data silos, lack of transparency, and manual verification.",
          "Blockchain creates a shared, tamper-proof ledger that enables real-time tracking, data integrity, and trusted collaboration across the entire supply chain.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Supply Chain Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Supply Chains"
        image={img15}
        paragraphs={[
          "Limited visibility, delayed data sharing, and counterfeit risks impact supply chain efficiency and customer trust.",
          "Blockchain solves these challenges by enabling traceability, automation, and secure information exchange among stakeholders.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Supply Chain"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Supply Chain Blockchain Solutions"
        subtitle="Built for transparency, efficiency, and scalability"
        features={[
          {
            icon: sIcon1,
            title: "Real-Time Tracking",
            description:
              "Monitor shipments and inventory across the supply chain.",
          },
          {
            icon: sIcon2,
            title: "Immutable Audit Trails",
            description:
              "Permanent records for compliance and dispute resolution.",
          },
          {
            icon: sIcon3,
            title: "Smart Contract Execution",
            description:
              "Automated payments and agreement enforcement.",
          },
          {
            icon: sIcon4,
            title: "Anti-Counterfeit Measures",
            description:
              "Verify product authenticity at every stage.",
          },
          {
            icon: sIcon5,
            title: "System Integration",
            description:
              "Integrate blockchain with ERP, IoT, and logistics systems.",
          },
          {
            icon: sIcon6,
            title: "Scalable Architecture",
            description:
              "Support global supply chain operations efficiently.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expertise in blockchain-based supply chain systems",
          "Security-first and transparency-driven solutions",
          "End-to-end development and integration support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
